import React, { createContext, FC, ReactNode, useContext, useMemo } from 'react';
import type { Socket } from 'socket.io-client';

export interface ISocketContextProps {
	socket: Socket | null;
	isConnected: boolean;
	connect: (token?: string) => void;
	disconnect: () => void;
}

export const SocketContext = createContext<ISocketContextProps>({
	socket: null,
	isConnected: false,
	connect: () => {},
	disconnect: () => {},
});

interface ISocketContextProviderProps {
	children: ReactNode;
}

/**
 * Socket Context Provider (DISABLED)
 * WebSocket connection and polling are completely disabled.
 * Notifications are managed exclusively by Firebase Cloud Messaging.
 */
export const SocketContextProvider: FC<ISocketContextProviderProps> = ({ children }) => {
	const value = useMemo<ISocketContextProps>(
		() => ({
			socket: null,
			isConnected: false,
			connect: () => {},
			disconnect: () => {},
		}),
		[],
	);

	return <SocketContext.Provider value={value}>{children}</SocketContext.Provider>;
};

export const useSocket = (): ISocketContextProps => useContext(SocketContext);

export default SocketContext;
